import { CatalogTreeCardObject } from 'src/app/models/catalog/catalog-tree-item-object.model';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { CatalogInfoObject } from 'src/app/models/catalog/catalog-info-object.model';

@Component({
  selector: 'app-catalog-tabs',
  templateUrl: './catalog-tabs.component.html',
  styleUrls: ['./catalog-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogTabsComponent implements OnInit {

  @Input() info: CatalogInfoObject;
  @Input() node: CatalogTreeCardObject;


  constructor() {
    
  }


  ngOnInit() {
    this.info = CatalogInfoObject.create();
    this.node = CatalogTreeCardObject.create();
  }



}
